import { useQuery } from '@tanstack/react-query';
import {
  notificationsQuery,
  unseenNotificationsCountQuery,
} from 'networking/mindfeed/queries/notifications';
import { useAuthentication } from 'xstate/hooks/useAuthentication';

// The signed-in user's notification feed.
export const useNotifications = () => {
  const { isAuthenticated } = useAuthentication();
  return useQuery({ ...notificationsQuery(), enabled: isAuthenticated });
};

// How many notifications the user hasn't seen yet (the rail badge).
export const useUnseenNotificationsCount = () => {
  const { isAuthenticated } = useAuthentication();
  return useQuery({
    ...unseenNotificationsCountQuery(),
    enabled: isAuthenticated,
  });
};
